import { isPlatformServer, Location } from '@angular/common';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import {
    ApiService,
    KnowledgebaseDomainErrorCode,
} from 'app/core/services/api.service';
import { KbService } from 'app/core/services/kb.service';
import { take } from 'rxjs';

@Component({
    selector: 'page-404-knowledgebase',
    template: `
        <div
            class="absolute inset-0 flex min-h-screen w-full flex-col overflow-y-auto bg-[#F8F9FB]"
            cdkScrollable>
            <div
                class="flex flex-1 items-center justify-center px-6 py-10 md:px-10 lg:px-16">
                <div
                    class="flex w-full max-w-[1200px] flex-col items-center gap-10 md:flex-row md:items-center md:gap-16 lg:gap-24">
                    <div
                        class="flex w-full shrink-0 justify-center md:w-auto md:max-w-[45%]">
                        <img
                            [src]="'logo-knowledgebase.svg' | imagePath"
                            alt=""
                            class="w-full object-contain"/>
                    </div>
                    <div class="flex w-full max-w-[637px] flex-col items-start text-left">
                    <h1
                        class="text-[72px] font-['Poppins'] uppercase font-bold leading-none text-heading-primary sm:text-[90px] sm:leading-[110px]">
                        <img
                            [src]="
                                (errorCode == 410
                                    ? '410-knowledgebase.png'
                                    : '404-knowledgebase.png') | imagePath"
                            alt=""
                            class="w-full object-contain"/>
                    </h1>
                        <h2 class="mt-5 font-['Poppins'] text-[38px] font-medium text-heading-primary">
                            {{
                                (errorCode == 410
                                    ? 'KB_DOCS.KB_NO_LONGER_AVAILABLE'
                                    : 'KB_DOCS.PAGE_NOT_FOUND'
                                ) | translate
                            }}
                        </h2>
                        <p class="mt-4 font-['Poppins'] text-[22px] font-normal text-info">
                            {{
                                (errorCode == 410
                                    ? 'KB_DOCS.KB_NO_LONGER_AVAILABLE_DESCRIPTION'
                                    : 'KB_DOCS.PAGE_NOT_FOUND_DESCRIPTION'
                                ) | translate
                            }}
                        </p>
                        <div *ngIf="showHomeLink"
                            class="mt-8 flex flex-wrap items-center gap-3">
                            <button
                                type="button"
                                class="font-['Poppins'] inline-flex h-12 items-center justify-center rounded-md bg-white border border-primary px-4 py-[14px] text-base font-medium leading-none text-primary hover:bg-primary hover:text-white transition-all duration-300"
                                [routerLink]="kbHomeLink">
                                {{ 'KB_DOCS.VISIT_KNOWLEDGEBASE' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: [],
    host: { class: 'w-full h-full block' },
})
export class Error404KnowledgebaseComponent implements OnInit {
    kbHomeLink: string[] = ['/'];
    errorCode: KnowledgebaseDomainErrorCode = 404;
    errorCodeKey = 'KB_DOCS.ERROR_404';
    showHomeLink = true;

    constructor(
        private _matDialog: MatDialog,
        private _kbSer: KbService,
        private _location: Location,
        private _api: ApiService,
        @Inject(PLATFORM_ID) private _platformId: object,
        @Optional() @Inject(RESPONSE) private _response: { status: (code: number) => unknown; headersSent?: boolean } | null,
    ) {
        this._matDialog.closeAll();
    }

    ngOnInit(): void {
        const resolvedCode = this._api.getKnowledgebaseErrorCode();

        this.errorCode = resolvedCode;
        this.errorCodeKey = `KB_DOCS.ERROR_${resolvedCode}`;
        this.showHomeLink = resolvedCode !== 410;

        if (isPlatformServer(this._platformId) && this._response && !this._response.headersSent) {
            this._response.status(resolvedCode === 410 ? 410 : 404);
        }

        const { kb_slug, kb_lang } = this._kbSer.getPortalContext();
        const slug = kb_slug || this._kbSer.kbSettings?.kb_slug;
        const lang = kb_lang || this._kbSer.kbSettings?.language;

        if (slug && lang) {
            this.kbHomeLink = ['/', slug, lang];
            return;
        }

        this._kbSer
            .getKbslugDetails()
            .pipe(take(1))
            .subscribe((details) => {
                const resolvedSlug = details?.default_kb_slug;
                const resolvedLang = details?.default_language;
                if (resolvedSlug && resolvedLang) {
                    this.kbHomeLink = ['/', resolvedSlug, resolvedLang];
                }
            });
    }

    goBack(): void {
        this._location.back();
    }
}
